export const MARKETING_COVER_ENABLED = false;

export const BANNERS_ENABLED = true;

export const DEFAULT_TITLE = `Fictionate.me: Open platform for readers and writers`;

export const DEFAULT_META_DESCRIPTION = "Discover contemporary writers, and read their novels with weekly updates.";

export const DEFAULT_META_IMAGE = "https://fictionate.me/zaglushka.jpg";
